import { useDeletePlaybookMutation } from '@carboncopyco/data';
import { DeleteOutlineIcon } from '@carboncopyco/icons';
import type { Folder } from '@carboncopyco/types';
import { ConfirmAlert, notify } from '@carboncopyco/ui';
import { useBoolean } from 'ahooks';

type ArchivePlaybookModalProps = {
  organizationId: string;
  workspaceId: string;
  playbookId: string;
  onClose: () => void;
  show: boolean;
  navigateOnSuccess?: () => void;
  folderId?: Folder['id'];
};

export const ArchivePlaybookModal = ({
  organizationId,
  playbookId,
  show,
  onClose,
  navigateOnSuccess,
  folderId,
  workspaceId,
}: ArchivePlaybookModalProps) => {
  const [archivePlaybook, { isLoading }] = useDeletePlaybookMutation();
  const [isDisabled, setIsDisabled] = useBoolean();

  return (
    <ConfirmAlert
      disabled={isDisabled}
      loading={isLoading}
      title="Archive playbook"
      description="This playbook will no longer be accessible unless it’s restored."
      show={show}
      onConfirm={() => {
        setIsDisabled.setTrue();
        archivePlaybook({
          id: playbookId,
          workspaceId,
          organizationId,
          folderId,
        })
          .unwrap()
          .then(() => {
            navigateOnSuccess?.();
            notify.success('Archived playbook successfully');
          })
          .catch(() => notify.error('Error archiving playbook'))
          .finally(() => {
            setIsDisabled.setFalse();
            onClose();
          });
      }}
      onClose={onClose}
      danger
      containerClass="w-ds-normal-modal"
      yesIcon={<DeleteOutlineIcon />}
      yesLabel="Archive"
    />
  );
};
